export enum AvailabilityConsolidateEnum {
  CUSTOMER = 'CUSTOMER',
  INDUSTRY = 'INDUSTRY',
}